import React, { PureComponent } from 'react';
import SpotifyPlayer from 'library/SpotifyPlayer';
import BandcampPlayer from 'library/BandcampPlayer';
import SoundcloudPlayer from 'library/SoundcloudPlayer';
import spotifyUri from 'spotify-uri';

export class AlbumPlayer extends PureComponent {
  render() {
    const {featuredAlbum} = this.props;
    const spotifyUrl = featuredAlbum.outlets.spotify
    const hasSpotify = spotifyUrl !== undefined && spotifyUrl.length != 0;
    const hasBandcamp = featuredAlbum.outlets.bandcamp !== undefined && featuredAlbum.outlets.bandcamp.length != 0;
    const hasSoundcloud = featuredAlbum.outlets.soundcloud !== undefined && featuredAlbum.outlets.soundcloud.length != 0;

    let mediaPlayer = null;

    if(hasSpotify) {
      const parsed = spotifyUri.parse(spotifyUrl);
      const uri = spotifyUri.formatURI(parsed);
      mediaPlayer =
        <SpotifyPlayer
          uri={uri}
          size='compact'
          view='coverart'
          theme='white'
        />;
    } else if (hasBandcamp) {
      const uri = featuredAlbum.outlets.bandcamp;
      mediaPlayer =
        <BandcampPlayer
        src={uri}
        size="small"
        tracklist="false"
        height="42px"
      />
    } else if (hasSoundcloud) {
      const uri = featuredAlbum.outlets.soundcloud;
      mediaPlayer =
        <SoundcloudPlayer
          url={uri}
        />
    }

    return(
      <div>
        {mediaPlayer}
      </div>
    );
  }
};
